
import { Component, Vue } from 'vue-property-decorator';
import TagRepositoryInterface, { TagInterface } from '../../../../services/QA/tag/interfaces';
import { DataTableHeader } from 'vuetify';
import Themeable from 'vuetify/lib/mixins/themeable';
import DeleteTagDialog from '@/components/dialogs/qa/tag/DeleteTagDialog.vue';

@Component({
  mixins: [
    Themeable,
  ],
  components: {
    DeleteTagDialog,
  },
  inject: [
    'tagRepository',
  ],
})
export default class AllTags extends Vue {
  private loading: boolean = true;
  private tags: TagInterface[] = [];

  private search: string = '';
  private headers: DataTableHeader[] = [
    { text: 'ID', value: 'id' },
    { text: 'Label', value: 'label' },
    { text: 'Color', value: 'color' },
    { text: 'Deleted', value: 'deletedAt' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  private readonly tagRepository!: TagRepositoryInterface;
  private deleteTagDialog: string = '';
  private deleteTagForDialog: TagInterface | false = false

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    this.tags = await this.tagRepository.getAllTags();
    this.loading = false;
  }

  private async createTag(): Promise<void> {
    await this.$router.push({ name: 'tag_create' });
  }

  private async editTag(tagId: number): Promise<void> {
    await this.$router.push({ name: 'tag_update', params: { tagId: String(tagId) } });
  }

  private async deleteTag(tag: TagInterface): Promise<void> {
    this.deleteTagForDialog = tag;
    this.deleteTagDialog = 'delete-tag-dialog'
  }
}
